import { createApp } from 'vue';
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import App from './App.vue';
import router from './router';
import i18n from './plugins/i18n';
import axios from './plugins/axios';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import PreLoader from '@/components/PreLoader.vue';


const app = createApp(App);
const pinia = createPinia();

// Pinia Persisted State Plugin
pinia.use(piniaPluginPersistedstate);

// Global Axios Instance
app.config.globalProperties.$axios = axios;
app.provide('axios', axios); // Alternative for provide/inject

// Global Components
app.component('PreLoader', PreLoader);

// Plugins
app.use(i18n);
app.use(pinia);
app.use(router);

// Mount the App
app.mount('#app');

// Initialize AOS
AOS.init({
  duration: 1000, // Animation duration (in ms)
  easing: 'ease-out', // Easing function
  once: true, // If true, animations will only happen once
});

// Refresh AOS after route changes
router.afterEach(() => {
  AOS.refresh();
});

// Global Axios Error Handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Axios Error:', error);
    return Promise.reject(error);
  }
);